<template>
  <div class="home">

    <van-nav-bar>
      <template #left>
        <span style="font-weight:600;font-size:17px;">房间列表</span>
      </template>
      <template #right>
        <van-search v-model="value"
                    show-action
                    shape="round"
                    background="transparent"
                    @search="onSearch"
                    placeholder="请输入房间号搜索">
          <template #action>
            <span>搜索</span>
          </template>
        </van-search>
      </template>
    </van-nav-bar>

    <van-dropdown-menu active-color="#1989fa">
      <van-dropdown-item v-model="value1"
                         :options="option1" />
      <van-dropdown-item v-model="value2"
                         :options="option2" />

    </van-dropdown-menu>

    <!-- <div class="title"></div> -->

    <div class="content">
      <div class="content_item"
           v-for="item in roomList"
           @click="goDetail(item)">

        <div class="item_name">
          <van-icon :name="require('../assets/room.png')"
                    color="#696136" />
          {{item.name}}
        </div>
        <div class="item_address">{{item.address}}</div>
      </div>
    </div>

    <!-- <HomeList msg="Welcome to Your Vue.js App" /> -->
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  components: {
  },
  data() {
    return {
      value: '',
      roomList: [
        { id: 1, name: '302室', address: '13栋2单元302' },
        { id: 2, name: '502室', address: '15栋3单元502' },
        { id: 3, name: '102室', address: '15栋3单元102' },
        { id: 4, name: '202室', address: '15栋3单元202' },
        { id: 5, name: '302室', address: '15栋3单元302' },
      ],
      value1: 0,
      value2: 'a',
      option1: [
        { text: '全部房间', value: 0 },
        { text: '1栋', value: 1 },
        { text: '2栋', value: 2 },
      ],
      option2: [
        { text: '默认状态', value: 'a' },
        { text: '水表欠费', value: 'b' },
        { text: '电表欠费', value: 'c' },
      ],
    }
  },
  methods: {
    onSearch() {
      console.log('搜索')
      alert('?')
    },
    goDetail(id) {
      console.log(id)
      console.log(this.$router.push('/detail'))
    }
  },

  created() {
    // this.$toast.loading({
    //   duration: 0,
    //   mask: true,
    //   forbidClick: true,
    //   message: '加载中...',
    //   loadingType: 'spinner'
    // })

    // setTimeout(() => {
    //   this.$toast.clear()
    // }, 3000)
  }
}
</script>

<style scoped lang="less">
.home {
  // height: 100%;
  // background: #f7f7fc;
}

.title {
  height: 140px;
  background: rgb(47, 131, 245);
  background: linear-gradient(
    90deg,
    rgba(47, 131, 245, 0.955284274354273) 0%,
    rgba(148, 187, 233, 1) 100%
  );

  .van-search {
    margin: 0 12px;
    display: flex;
    align-items: center;
  }
  .van-search__action {
    margin-top: -7px;
  }
}

.content {
  margin: 0 20px;
  // margin-top: -120px;
  margin-top: 5px;
  text-align: start;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.title_font {
  font-size: 20px;
}

.content_item {
  width: 42%;
  padding: 10px;
  height: 70px;
  background: white;
  margin: 5px 2px;
  box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.1);
}

.item_name {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 17px;
}

.item_address {
  margin-top: 10px;
  overflow: hidden;
  white-space: normal;
  word-break: break-word;
}
</style>
